import { makeStyles, Grid, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import ColorTile from '../_components/ColorTile'
import SWLink from '../_components/SWLink'

const CUSTOM_FONT_SW = 'CustomFont-SW'

const useStyles = makeStyles<Theme, ColorOfTheYearProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    },
    colorOfTheYear: {
      background: '#f5f4ee',
      padding: '70px 40px',
      display: 'flex',
      flexDirection: 'column',
      gap: '80px',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        gap: '50px'
      }
    },
    colorOfTheYearHeader: {
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center'
      }
    },
    colorOfTheYearContent: {
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        justifyContent: 'center'
      },
      [theme.breakpoints.down('md')]: {
        marginTop: '20px'
      },
      [theme.breakpoints.down('sm')]: {
        marginLeft: '80px'
      },
      [theme.breakpoints.down('xs')]: {
        marginLeft: '0px',
        textAlign: 'center'
      }
    },
    subTitle: {
      fontFamily: CUSTOM_FONT_SW,
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '16px',
      letterSpacing: '1.5px',
      textTransform: 'uppercase'
    },
    title: {
      fontFamily: CUSTOM_FONT_SW,
      fontSize: '44px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '48px',
      letterSpacing: '-1.5px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '36px'
      }
    },
    description: {
      fontFamily: CUSTOM_FONT_SW,
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '-0.5px'
    },
    pairsWellTitle: {
      fontFamily: CUSTOM_FONT_SW,
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '-0.5px'
    },
    colorTile: {
      position: 'absolute',
      right: '-15px',
      bottom: '-20px',
      [theme.breakpoints.down(350)]: {
        right: '0px'
      }
    }
  }),
  { name: 'ColorOfTheYear' }
)

export interface ColorOfTheYearProps {
  classes?: StyleClasses<typeof useStyles>
}

function ColorOfTheYear(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <div className={classes.colorOfTheYear}>
        <Grid container md={12} className={classes.colorOfTheYearHeader}>
          <Grid item lg={6} md={7} sm={9} style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ position: 'relative', width: '358px', height: '339px' }}>
              <div
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '338px',
                  overflow: 'hidden'
                }}
              >
                <img
                  src={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/color-of-the-year-2026.png'}
                  alt="Color of the Year 2026 - Universal Khaki"
                  style={{ minWidth: '100%', height: '100%' }}
                />
              </div>
              <div className={classes.colorTile}>
                <ColorTile color={'#b7a790'} colorCode={6150} colorName="Universal Khaki" darkText tall />
              </div>
            </div>
          </Grid>
          <Grid
            item
            container
            lg={6}
            md={5}
            sm={8}
            direction="column"
            spacing={1}
            className={classes.colorOfTheYearContent}
          >
            <Grid item>
              <Typography variant="h2" className={classes.subTitle}>
                Introducing
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h2" className={classes.title}>
                2026 Color of the Year
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1" className={classes.description}>
                Find strength in simplicity with Universal Khaki SW 6150, an essential neutral selected by our color
                experts for its beautiful balance of livability and longevity.
              </Typography>
            </Grid>
            <Grid item>
              <SWLink
                label="ORDER FREE CHIPS"
                href="https://samples.sherwin-williams.com/?utm_source=paintscout&utm_medium=referral&utm_campaign=2024-poc"
                theme="dark"
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default ColorOfTheYear
